import { connect } from 'react-redux';
import _ from 'lodash';

const OnlyCore = (props) => (props.experience === 'core' && props.children) || null; 
export default connect(state => ({ experience: _.get(state.app, 'APP_EXPERIENCE') }))(OnlyCore);
